import React from 'react';
import { Button } from 'decap-cms-ui-next';
import { jsx as ___EmotionJSX } from "@emotion/react";
export function ControlButton({
  active,
  onClick,
  children
}) {
  return ___EmotionJSX(Button, {
    type: "neutral",
    variant: active ? 'solid' : 'soft',
    onClick: onClick,
    hasMenu: true
  }, children);
}